import { useEffect } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { NumberInput } from '@/schemas/sceneDataSchema';
import { TextField, FormControl } from '@mui/material';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';
import { useFieldBinding, seedFormFromStore } from '@/hooks/use-field-binding';

export const InputNumberFormElement = ({ form, component }: { form: UseFormReturn; component: NumberInput }) => {
  const key = encodeFieldKey(component);
  const binding = useFieldBinding(component, form);

  useEffect(() => {
    seedFormFromStore(form, key, binding.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Controller
      control={form.control}
      name={key}
      render={({ field, fieldState: { error } }) => (
        <FormControl
          fullWidth
          error={!!error}
        >
          <TextField
            type={'text'}
            label={component.label || 'Please enter'}
            variant='outlined'
            fullWidth
            role='textbox'
            error={!!error}
            placeholder={component.label || 'Please enter'}
            helperText={error ? error.message : component.description}
            {...field}
            onChange={(e) => {
              const raw = e.target.value;
              const numeric = raw === '' ? null : Number(raw);
              field.onChange(raw);
              binding.sync(isNaN(numeric!) ? raw : numeric);
            }}
            onBlur={() => {
              field.onBlur();
              binding.onBlur();
            }}
            value={isNaN(Number(field.value)) ? '' : (field.value as number)}
          />
        </FormControl>
      )}
    />
  );
};
